export const LAYOUT_CONTAINER_WIDTH_PX = 696;